/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    const module = this;
    const signsDecor = document.querySelector(".js-signs-decor");
    module.initedSwipers = {}

    const Settings = {
        global: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
                    const sliderName = swiperContainer.getAttribute("data-slider-name") || "global";

                    if (!module.initedSwipers.hasOwnProperty(sliderName)) {
                        module.initedSwipers[sliderName] = swiper;
                    }
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        sliderTrigger: sliderTrigger,
                        sliderName: sliderName,
                    }
                }
            },

            breakpoints: {
                1024: {
                    slidesPerView: 3,
                }
            }
        },

        banners: {
            slidesPerView: 1,
            spaceBetween: 12,
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: true,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            autoHeight: true,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
                    const sliderName = swiperContainer.getAttribute("data-slider-name") || "banners";

                    if (!module.initedSwipers.hasOwnProperty(sliderName)) {
                        module.initedSwipers[sliderName] = swiper;
                    }
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        sliderTrigger: sliderTrigger,
                        sliderName: sliderName,
                    }
                }
            },

            breakpoints: {
                1024: {
                    spaceBetween: 24
                }
            }
        },

        signs: {
            slidesPerView: 1,
            spaceBetween: 12,
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            // followFinger: true,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 1600,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
                    const sliderName = swiperContainer.getAttribute("data-slider-name") || "signs";

                    if (!module.initedSwipers.hasOwnProperty(sliderName)) {
                        module.initedSwipers[sliderName] = swiper;
                    }
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        sliderTrigger: sliderTrigger,
                        sliderName: sliderName,
                    }
                },

                slidePrevTransitionStart: function () {
                    const swiper = this;
                    const description = swiper.slides[swiper.activeIndex + 1].querySelector(".js-signs-description");
                    const prevDescription = swiper.slides[swiper.activeIndex].querySelector(".js-signs-description");
                    description.style.opacity = 0;
                    description.style.transform = "translateY(100%)";
                    prevDescription.style.opacity = 1;
                    prevDescription.style.transform = "translateY(0)";
                    const angle = 90 * swiper.activeIndex;
                    signsDecor.style.transform = `translate(-50%) rotate(${angle}deg)`;
                },

                slideNextTransitionStart: function () {
                    const swiper = this;
                    const description = swiper.slides[swiper.activeIndex - 1].querySelector(".js-signs-description");
                    const nextDescription = swiper.slides[swiper.activeIndex].querySelector(".js-signs-description");
                    description.style.opacity = 0;
                    description.style.transform = "translateY(-100%)";
                    nextDescription.style.opacity = 1;
                    nextDescription.style.transform = "translateY(0)";
                    const angle = 90 * swiper.activeIndex;
                    signsDecor.style.transform = `translate(-50%) rotate(${angle}deg)`;
                }
            },

            breakpoints: {
                1024: {
                    spaceBetween: 24
                }
            }
        },

        publications: {
            slidesPerView: 1.04,
            spaceBetween: 12,
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
                    const sliderName = swiperContainer.getAttribute("data-slider-name") || "publications";

                    if (!module.initedSwipers.hasOwnProperty(sliderName)) {
                        module.initedSwipers[sliderName] = swiper;
                    }
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        sliderTrigger: sliderTrigger,
                        sliderName: sliderName,
                    }
                }
            },

            breakpoints: {
                768: {
                    slidesPerView: 2.1,
                    spaceBetween: 16
                },

                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24
                }
            }
        },

        actionPictures: {
            slidesPerView: 1,
            simulateTouch: true,
            spaceBetween: 10,
            watchOverflow: true,
            followFinger: true,
            freeModeMomentum: false,
            speed: 500,
            effect: 'fade',
            mousewheel: {
                eventsTarget: "[data-multiple-slider]",
                enabled: true,
                sensitivity: 0,
                releaseOnEdges: true
            },
            fadeEffect: {
                crossFade: true
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
                    const sliderName = sliderTrigger.getAttribute("data-slider-1") || swiperContainer.getAttribute("data-slider-name") || "actionPictures";

                    if (!module.initedSwipers.hasOwnProperty(sliderName)) {
                        module.initedSwipers[sliderName] = swiper;
                    }
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        sliderTrigger: sliderTrigger,
                        sliderName: sliderName,
                    }

                    const multipleSliderContainer = sliderTrigger.closest("[data-multiple-slider]");
                    const secondSliderTrigger = multipleSliderContainer && multipleSliderContainer.querySelector("[data-slider-2]");

                    swiper.params.custom.secondSliderName = secondSliderTrigger && secondSliderTrigger.getAttribute("data-slider-2");

                    let sliderSettingsKey = secondSliderTrigger && secondSliderTrigger.getAttribute("data-slider-settings"); // получаем data-атрибут
                    const sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

                    if (sliderSettingsKey && sliderSettingsObject) {
                        new itsoftApp.modules.slidersLibrary.callback(secondSliderTrigger, sliderSettingsObject);
                    } else {
                        new itsoftApp.modules.slidersLibrary.callback(secondSliderTrigger);
                    }
                },

                slideChange: function () {
                    // if (isSyncing) return; // Прерываем, если уже идёт синхронизация
                    const swiper = this;
                    let dependentInitedSlider2 = module.initedSwipers.hasOwnProperty(swiper.params.custom.secondSliderName) && module.initedSwipers[swiper.params.custom.secondSliderName];

                    if (dependentInitedSlider2 && !dependentInitedSlider2.animating) {
                        dependentInitedSlider2.slides.forEach(slide => {
                            slide.classList.remove('js-active-slide');
                        });

                        const activeSlide = dependentInitedSlider2.slides[this.activeIndex];
                        if (activeSlide) {
                            activeSlide.classList.add('js-active-slide');
                        }
                        // dependentInitedSlider2.slideTo(this.activeIndex, false, false);
                    }
                }
            },
        },

        actionTexts: {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 12,
            speed: 500,
            simulateTouch: true,
            // followFinger: true,
            // allowTouchMove: true,
            watchOverflow: true,
            slideToClickedSlide: true,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderTrigger = swiperContainer.closest("[data-slider-2]");
                    const sliderName = sliderTrigger.getAttribute("data-slider-2") || swiperContainer.getAttribute("data-slider-name") || "actionText";

                    if (!module.initedSwipers.hasOwnProperty(sliderName)) {
                        module.initedSwipers[sliderName] = swiper;
                    }
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        sliderTrigger: sliderTrigger,
                        sliderName: sliderName,
                    }

                    const multipleSliderContainer = sliderTrigger.closest("[data-multiple-slider]");
                    const firstSliderTrigger = multipleSliderContainer && multipleSliderContainer.querySelector("[data-slider-1]");

                    swiper.params.custom.mainSliderName = firstSliderTrigger && firstSliderTrigger.getAttribute("data-slider-1");

                    module.initedSwipers[sliderName].controller.control = module.initedSwipers[swiper.params.custom.mainSliderName];
                    module.initedSwipers[swiper.params.custom.mainSliderName].controller.control = module.initedSwipers[sliderName];

                    swiper.slides[0].classList.add("js-active-slide");

                    let mainSlider1 = module.initedSwipers.hasOwnProperty(swiper.params.custom.mainSliderName) && module.initedSwipers[swiper.params.custom.mainSliderName];

                    // if (mainSlider1 && !mainSlider1.animating) {
                    //     // mainSlider1.slideTo(this.activeIndex, false, false);
                    // }

                    const onSlideClick = function (index) {
                        if (mainSlider1) { // && !mainSlider1.animating - ломает слайдер
                            mainSlider1.slideTo(index, 500, true);
                        }
                    }

                    swiper.slides.forEach((slide, index) => {
                        slide.addEventListener("click", function (evt) {
                            evt.preventDefault();
                            onSlideClick(index);
                        });
                    });
                },

                slideChange: function () {
                    const swiper = this;
                    let mainSlider1 = module.initedSwipers.hasOwnProperty(swiper.params.custom.mainSliderName) && module.initedSwipers[swiper.params.custom.mainSliderName];

                    // if (mainSlider1 && !mainSlider1.animating) {
                    //     mainSlider1.slideTo(this.activeIndex, false, false);
                    // }
                }
            },

            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                    direction: 'vertical',
                },

                1024: {
                    slidesPerView: 3,
                    spaceBetween: 39,
                    direction: 'vertical'
                }
            }
        },

        tabsButtons: {
            simulateTouch: false,
            slideToClickedSlide: true,
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }

                    const target = swiperContainer.closest(".js-scroll-trigger.js-hash-nav");

                    if (target) {
                        target.classList.add("js-visible");

                        itsoftApp.modules.scrollActions.callback(target, true, false);
                    }
                }
            }
        },

        brands: {
            slidesPerView: 2,
            spaceBetween: 8,
            simulateTouch: false,
            slidesPerColumn: 2,
            slidesPerColumnFill: 'row',
            slidesPerGroup: 2,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
                    const sliderName = swiperContainer.getAttribute("data-slider-name") || "global";

                    if (!module.initedSwipers.hasOwnProperty(sliderName)) {
                        module.initedSwipers[sliderName] = swiper;
                    }
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        sliderTrigger: sliderTrigger,
                        sliderName: sliderName,
                    }
                }
            },

            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                    slidesPerColumn: 1,
                    slidesPerGroup: 1,
                },

                1024: {
                    slidesPerView: 4,
                    spaceBetween: 28,
                    slidesPerColumn: 1,
                    slidesPerGroup: 1,
                }
            }
        },
    };

    const getSettings = function (slidersSettingsKey) {
        return Settings[slidersSettingsKey];
    };

    module.getSettings = getSettings;
});